// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__bgRvG","fadein":"LoadingScreen_fadein__aLKf7","spinner":"LoadingScreen_spinner__ACr5-","spinner-spin":"LoadingScreen_spinner-spin__eTpnz"};